export default function (state) {
    let date = new Date();
    let dateN = new Date();
    dateN.setDate(1);
    state.dates = [
        '' + (dateN.getDate() > 9 ? '' : '0') + dateN.getDate() + '.' + (dateN.getMonth() > 8 ? '' : '0') + (dateN.getMonth() + 1) + '.' + dateN.getFullYear(),
        '' + (date.getDate() > 9 ? '' : '0') + date.getDate() + '.' + (date.getMonth() > 8 ? '' : '0') + (date.getMonth() + 1) + '.' + date.getFullYear()
    ];
    state.AccountId = '';
    state.SubAccountId = '';
    state.ContragentId = '';
    state.ContragentName = '';
    state.CurrencyId = '';
    state.PaymentAccountId = '';
    state.WithTurns = false;
    state.WithDocumens = false;
}